/* interest-form.js v2 — private interest form + password-protected results */
'use strict';

(function () {
  var configEl = document.getElementById('ccInterestFormConfig');
  if (!configEl) return;

  var config = {};
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var endpoint = config.endpoint || '';
  var AUTH_KEY = 'homestar_interest_auth';

  function normalizePhone(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function showNotice(el, message, type) {
    if (!el) return;
    el.hidden = false;
    el.textContent = message;
    el.className = 'cc-interest__notice cc-interest__notice--' + type;
  }

  function resetSubmitButton(btn, label) {
    if (!btn) return;
    btn.disabled = false;
    btn.textContent = label || config.submitLabel || 'Submit';
  }

  function parseJsonResponse(res) {
    return res.text().then(function (text) {
      if (!text) throw new Error('Empty response from server.');
      try {
        return JSON.parse(text);
      } catch (e) {
        throw new Error('Unexpected response from server. Please try again.');
      }
    });
  }

  function postJson(payload, mode, signal) {
    return fetch(endpoint, {
      method: 'POST',
      mode: mode,
      signal: signal,
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    });
  }

  function submitInterestForm(payload) {
    var body = JSON.stringify(payload);

    if (navigator.sendBeacon) {
      try {
        var blob = new Blob([body], { type: 'text/plain;charset=utf-8' });
        if (navigator.sendBeacon(endpoint, blob)) {
          return Promise.resolve({ ok: true });
        }
      } catch (e) { /* fall through */ }
    }

    return fetch(endpoint, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: body,
      keepalive: true
    }).then(function () {
      return { ok: true };
    });
  }

  /* ── Interest form ── */
  var form = document.getElementById('ccInterestForm');
  var sizeGuide = document.querySelector('.cc-interest__size-guide');
  if (form) {
    var sizeSelect = document.getElementById('ccInterestSize');
    var sizeHint = document.getElementById('ccInterestSizeHint');
    var notice = document.getElementById('ccInterestNotice');
    var successPanel = document.getElementById('ccInterestSuccessPanel');
    var submitBtn = document.getElementById('ccInterestSubmitBtn') || form.querySelector('.cc-interest__submit');

    if (submitBtn && submitBtn.type === 'submit') {
      submitBtn.type = 'button';
    }

    var sizeData = {
      '27x28': 'Waist 26.6 in · Outseam 38.6 in · Leg opening 10.2 in',
      '28x29': 'Waist 28.4 in · Outseam 39.4 in · Leg opening 10.6 in',
      '30x30': 'Waist 29.8 in · Outseam 40.2 in · Leg opening 11.0 in',
      '31x31': 'Waist 31.4 in · Outseam 40.9 in · Leg opening 11.4 in',
      '33x32': 'Waist 33.0 in · Outseam 41.7 in · Leg opening 11.8 in',
      '35x32': 'Waist 34.6 in · Outseam 42.5 in · Leg opening 12.2 in',
      '36x33': 'Waist 36.2 in · Outseam 43.3 in · Leg opening 12.6 in',
      '38x34': 'Waist 37.8 in · Outseam 44.1 in · Leg opening 12.9 in'
    };

    if (sizeSelect && sizeHint) {
      sizeSelect.addEventListener('change', function () {
        sizeHint.textContent = sizeData[sizeSelect.value] || '';
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
    });

    function showSuccess() {
      form.classList.add('is-hidden');
      if (sizeGuide) sizeGuide.classList.add('is-hidden');
      if (notice) notice.hidden = true;

      var legacySuccess = document.getElementById('ccInterestSuccess');
      if (successPanel) {
        successPanel.hidden = false;
        successPanel.classList.add('is-visible');
      } else if (legacySuccess) {
        legacySuccess.hidden = false;
      }

      var intro = document.querySelector('.cc-interest__intro');
      if (intro) intro.hidden = true;

      var scrollTarget = successPanel || legacySuccess;
      if (scrollTarget) {
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function handleSubmit() {
      if (!endpoint) {
        showNotice(notice, 'Form is not configured yet. Add your Google Apps Script URL in Theme settings.', 'error');
        return;
      }

      var nameInput = document.getElementById('ccInterestName');
      var phoneInput = document.getElementById('ccInterestPhone');
      var emailInput = document.getElementById('ccInterestEmail');
      var sizeInput = document.getElementById('ccInterestSize');
      var notesInput = document.getElementById('ccInterestNotes');

      var phone = normalizePhone(phoneInput && phoneInput.value);
      if (phone.length < 10) {
        showNotice(notice, 'Please enter a valid mobile number.', 'error');
        return;
      }

      if (!sizeInput || !sizeInput.value) {
        showNotice(notice, 'Please select a size.', 'error');
        return;
      }

      var payload = {
        action: 'submit',
        name: (nameInput && nameInput.value || '').trim(),
        phone: (phoneInput && phoneInput.value || '').trim(),
        email: (emailInput && emailInput.value || '').trim(),
        size: sizeInput.value,
        notes: (notesInput && notesInput.value || '').trim()
      };

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending…';
      }
      if (notice) notice.hidden = true;

      submitInterestForm(payload)
        .then(function () {
          showSuccess();
        })
        .catch(function (err) {
          showNotice(notice, err.message || 'Something went wrong. Please try again.', 'error');
          if (submitBtn) resetSubmitButton(submitBtn);
        });
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', handleSubmit);
    }

    window.__ccInterestSubmit = handleSubmit;

    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
        handleSubmit();
      }
    });
  }

  /* ── Results page ── */
  var loginForm = document.getElementById('ccInterestLoginForm');
  var resultsPanel = document.getElementById('ccInterestResultsPanel');
  var loginNotice = document.getElementById('ccInterestLoginNotice');
  var resultsBody = document.getElementById('ccInterestResultsBody');
  var resultsCount = document.getElementById('ccInterestResultsCount');
  var exportBtn = document.getElementById('ccInterestExportBtn');
  var logoutBtn = document.getElementById('ccInterestLogoutBtn');

  function getStoredPassword() {
    try {
      return sessionStorage.getItem(AUTH_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function setStoredPassword(value) {
    try {
      if (value) sessionStorage.setItem(AUTH_KEY, value);
      else sessionStorage.removeItem(AUTH_KEY);
    } catch (e) {}
  }

  function renderRows(rows) {
    if (!resultsBody) return;

    if (!rows.length) {
      resultsBody.innerHTML = '<tr><td colspan="6" class="cc-interest-results__empty">No responses yet.</td></tr>';
      if (resultsCount) resultsCount.textContent = '0 responses';
      return;
    }

    if (resultsCount) {
      resultsCount.textContent = rows.length + (rows.length === 1 ? ' response' : ' responses');
    }

    resultsBody.innerHTML = rows.map(function (row) {
      return '<tr>' +
        '<td>' + escapeHtml(formatDate(row.Timestamp)) + '</td>' +
        '<td>' + escapeHtml(row.Name) + '</td>' +
        '<td>' + escapeHtml(row.Phone) + '</td>' +
        '<td>' + escapeHtml(row.Email) + '</td>' +
        '<td><strong>' + escapeHtml(row.Size) + '</strong></td>' +
        '<td>' + escapeHtml(row.Notes) + '</td>' +
      '</tr>';
    }).join('');
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatDate(value) {
    if (!value) return '';
    var d = new Date(value);
    if (isNaN(d.getTime())) return value;
    return d.toLocaleString();
  }

  function fetchResults(password) {
    if (!endpoint) {
      showNotice(loginNotice, 'Results backend is not configured. Add your Google Apps Script URL in Theme settings.', 'error');
      return Promise.reject();
    }

    return fetch(endpoint + '?action=list&password=' + encodeURIComponent(password), {
      method: 'GET',
      mode: 'cors'
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data.ok) throw new Error(data.error || 'Could not load responses');
        return data.rows || [];
      });
  }

  function showResults(password) {
    fetchResults(password).then(function (rows) {
      window.__homestarInterestRows = rows;
      if (loginForm) loginForm.hidden = true;
      if (resultsPanel) resultsPanel.hidden = false;
      renderRows(rows);
    }).catch(function (err) {
      setStoredPassword('');
      if (loginForm) loginForm.hidden = false;
      if (resultsPanel) resultsPanel.hidden = true;
      showNotice(loginNotice, err.message || 'Wrong password or connection error.', 'error');
    });
  }

  if (loginForm) {
    loginForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var password = loginForm.password.value;
      if (!password) return;
      setStoredPassword(password);
      showResults(password);
    });

    var saved = getStoredPassword();
    if (saved) showResults(saved);
  }

  if (logoutBtn) {
    logoutBtn.addEventListener('click', function () {
      setStoredPassword('');
      if (loginForm) {
        loginForm.hidden = false;
        loginForm.password.value = '';
      }
      if (resultsPanel) resultsPanel.hidden = true;
    });
  }

  if (exportBtn) {
    exportBtn.addEventListener('click', function () {
      var rows = window.__homestarInterestRows || [];
      if (!rows.length) return;

      var headers = Object.keys(rows[0]);
      var csv = [headers.join(',')].concat(rows.map(function (row) {
        return headers.map(function (h) {
          var cell = String(row[h] == null ? '' : row[h]).replace(/"/g, '""');
          return '"' + cell + '"';
        }).join(',');
      })).join('\n');

      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      var link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'homestar-interest-responses.csv';
      link.click();
    });
  }
})();
